export function normalizeResourceUrl(raw) {
  const t = (raw || '').trim()
  if (!t) return { ok: false, error: 'URL is required', url: null }
  const withScheme = /^https?:\/\//i.test(t) ? t : `https://${t}`
  try {
    const u = new URL(withScheme)
    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return { ok: false, error: 'Only http and https URLs are allowed', url: null }
    }
    return { ok: true, error: null, url: u.href }
  } catch {
    return { ok: false, error: 'Enter a valid URL', url: null }
  }
}

export function linkLabel(link) {
  const n = link.display_name?.trim()
  return n || link.url
}
